import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { AuthService } from '../services/shared/auth.service';
import { ToasterService } from '../shared/toaster/toaster.service';
import { SpinnerComponent } from '../shared/spinner/spinner.component';

@Component({
  selector: 'app-mindchange',
  standalone: true,
  imports: [SpinnerComponent],
  templateUrl: './mindchange.component.html',
  styleUrl: './mindchange.component.scss'
})
export class MindchangeComponent implements OnInit {
  selectedTab: 'liked' | 'disliked' = 'liked';

  likedUsers: any[] = [];
  dislikedUsers: any[] = [];
  spinner: boolean = false;
  spinMessage: string = '';

  constructor(
    private router: Router,
    private authService: AuthService,
    private toasterService: ToasterService
  ) {}

  ngOnInit(): void {
    this.fetchUserPreferences();
  }

  goBack() {
    this.router.navigate(['/home']);
  }

  fetchUserPreferences() {
    const token = sessionStorage.getItem('token');
    if (!token) return;

     this.spinner = true;
    this.spinMessage = 'Loading preferences...';

    this.authService.getUserPreferences(token).subscribe({
      next: (res: any) => {
        this.likedUsers = res.likedUsers || [];
        this.dislikedUsers = res.dislikedUsers || [];
        this.spinner = false;
        this.spinMessage = '';
      },
      error: (err) => {
        this.spinner = false;
        this.spinMessage = '';
        this.toasterService.showToast('Failed to fetch preferences ❌', err.error?.error || 'Error');
      }
    });
  }

  dislikeUser(user: any) {
    const token = sessionStorage.getItem('token');
    if (!token) return;

     this.spinner = true;
    this.spinMessage = 'Updating preferences...';

    this.authService.dislikeUser(user._id, token).subscribe({
      next: () => {
        this.likedUsers = this.likedUsers.filter(u => u._id !== user._id);
        this.dislikedUsers.push(user);
         this.spinner = false;
        this.spinMessage = '';
      },
      error: (err : any) => {
         this.spinner = false;
        this.spinMessage = '';
        this.toasterService.showToast('Failed to dislike user ❌', err.error?.error || 'Error');
      }
    });
  }

likeUser(user: any) {
  const token = sessionStorage.getItem('token');
  if (!token) return;

   this.spinner = true;
    this.spinMessage = 'Updating preferences...';

  this.authService.likeUser(user._id, token).subscribe({
    next: () => {
      const alreadyLiked = this.likedUsers.some(u => u._id === user._id);
      if (!alreadyLiked) {
        this.dislikedUsers = this.dislikedUsers.filter(u => u._id !== user._id);
        this.likedUsers.push(user);
      }
       this.spinner = false;
        this.spinMessage = '';
    },
    error: (err: any) => {
      // Check for the specific backend error message
       this.spinner = false;
        this.spinMessage = '';
      if (err.error?.error === 'You already liked this user') {
        this.toasterService.showToast('You already liked this user!', 'info');
      } else {
        this.toasterService.showToast('Failed to like user ❌', err.error?.error || 'Error');
      }
    }
  });
}
}
